import React from 'react';
import './machine-info.scss';
import history from 'state/history';
import { Routes } from 'state/ducks/routes';
import { localized } from 'state/i18n';
import BiTooltip from 'view/shared/components/bi-tooltip/bi-tooltip';
import { getIcon } from 'view/shared/utils/icon-helper';
import { chartGrayLight } from 'view/styles/colors';

interface AppProps {
	id: string;
	disabled?: boolean;
}

type Props = AppProps;

class MachineInfo extends React.PureComponent<Props> {
	public handleMachineDetails = () => {
		history.push(`${Routes.MachineDetails}/${encodeURIComponent(this.props.id)}`);
	};

	public handleUnitHistory = () => {
		if (this.props.disabled) return;
		history.push(`${Routes.UnitHistory}/${encodeURIComponent(this.props.id)}`);
	};

	public render() {
		return (
			<div className="flex-direction-row ">
				<BiTooltip overlay={localized('Tooltip_InfoDetails')}>
					<div className="margin-left-1 cursor-pointer" onClick={this.handleMachineDetails}>
						{getIcon('info-circle')}
					</div>
				</BiTooltip>
				<BiTooltip overlay={localized(this.props.disabled?'Tooltip_InfoHistory_Need_Subscription':'Tooltip_InfoHistory')}>
					<div className="margin-left-1 margin-right-1 cursor-pointer" onClick={this.handleUnitHistory}>
						{getIcon('history', undefined, this.props.disabled ? chartGrayLight : undefined)}
					</div>
				</BiTooltip>
			</div>
		);
	}
}

export default MachineInfo;
